import { toast } from 'react-toastify';
import { isFunction } from 'lodash';

import Api from 'lib/api';

const api = Api.getInstance();

const ns = 'app/asks/';

export const LOAD_START = ns + 'LOAD_START';
export const LOAD_SUCCESS = ns + 'LOAD_SUCCESS';
export const LOAD_FAILURE = ns + 'LOAD_FAILURE';

export const LOAD_CHAN_START = ns + 'LOAD_CHAN_START';
export const LOAD_CHAN_SUCCESS = ns + 'LOAD_CHAN_SUCCESS';
export const LOAD_CHAN_FAILURE = ns + 'LOAD_CHAN_FAILURE';

export const LOAD_CT_START = ns + 'LOAD_CT_START';
export const LOAD_CT_SUCCESS = ns + 'LOAD_CT_SUCCESS';
export const LOAD_CT_FAILURE = ns + 'LOAD_CT_FAILURE';

export const ADD_START = ns + 'ADD_START';
export const ADD_SUCCESS = ns + 'ADD_SUCCESS';
export const ADD_FAILURE = ns + 'ADD_FAILURE';

export const GET_START = ns + 'GET_START';
export const GET_SUCCESS = ns + 'GET_SUCCESS';
export const GET_FAILURE = ns + 'GET_FAILURE';

export const SAVE_START = ns + 'SAVE_START';
export const SAVE_SUCCESS = ns + 'SAVE_SUCCESS';
export const SAVE_FAILURE = ns + 'SAVE_FAILURE';

export const DELETE_START = ns + 'DELETE_START';
export const DELETE_SUCCESS = ns + 'DELETE_SUCCESS';
export const DELETE_FAILURE = ns + 'DELETE_FAILURE';

export const CLONE_START = ns + 'CLONE_START';
export const CLONE_SUCCESS = ns + 'CLONE_SUCCESS';
export const CLONE_FAILURE = ns + 'CLONE_FAILURE';

export const TERMS_LOAD = ns + 'TERMS_LOAD';
export const TERMS_LOADED = ns + 'TERMS_LOADED';
export const TERMS_ERROR = ns + 'TERMS_ERROR';

export const NONPROFITS_LOADED = ns + 'NONPROFITS_LOADED';

export function load(page = 1, archived = false) {
  return async dispatch => {
    dispatch({
      type: LOAD_START
    });

    try {
      const response = await api.get('asks', {
        params: { page: page, archived: archived }
      });
      const { data } = response;

      dispatch({
        type: LOAD_SUCCESS,
        payload: data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: LOAD_FAILURE,
        payload: response
      });
    }
  };
}

export function getChannels() {
  return async dispatch => {
    dispatch({
      type: LOAD_CHAN_START
    });

    try {
      const response = await api.get('channels');
      const { data } = response;

      dispatch({
        type: LOAD_CHAN_SUCCESS,
        payload: data.networks
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: LOAD_CHAN_FAILURE,
        payload: response
      });
    }
  };
}

export function getContacts() {
  return async dispatch => {
    dispatch({
      type: LOAD_CT_START
    });

    try {
      const response = await api.get('nonprofits/contacts');
      const { data } = response;

      dispatch({
        type: LOAD_CT_SUCCESS,
        payload: data.contacts
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: LOAD_CT_FAILURE,
        payload: response
      });
    }
  };
}

export function getNonprofits() {
  return async dispatch => {
    const response = await api.get('nonprofits/list');
    const { data } = response;

    if (data.success) {
      dispatch({
        type: NONPROFITS_LOADED,
        payload: data.nonprofits
      });
    }
  };
}

export function add(values, callback) {
  return async dispatch => {
    dispatch({
      type: ADD_START
    });

    try {
      const response = await api.post('asks', values);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: ADD_SUCCESS
        });

        toast.success('Sponsorship created successfully!');

        if (callback && isFunction(callback)) {
          callback();
        }

        /*if (resetForm && isFunction(resetForm)) {
          resetForm();
        }*/
      } else {
        toast.error('Unable to create sponsorship.');

        dispatch({
          type: ADD_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: ADD_FAILURE,
        payload: response
      });
    }
  };
}

export function edit(askId) {
  return async dispatch => {
    dispatch({
      type: GET_START
    });

    try {
      const response = await api.get(`asks/${askId}`);
      const { data } = response;

      dispatch({
        type: GET_SUCCESS,
        payload: data.data
      });
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: GET_FAILURE,
        payload: response
      });
    }
  };
}

export function save(askId, values, history, resetForm) {
  return async dispatch => {
    dispatch({
      type: SAVE_START
    });

    try {
      const response = await api.put(`asks/${askId}`, values);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: SAVE_SUCCESS
        });

        toast.success('Sponsorship saved successfully!');

        if (resetForm && isFunction(resetForm)) {
          resetForm();
        }

        history.push('/sponsorships?type=open');
      } else {
        toast.error('Unable to save sponsorship.');

        dispatch({
          type: SAVE_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SAVE_FAILURE,
        payload: response
      });
    }
  };
}

export function deleteAsk(user, callback) {
  return async dispatch => {
    dispatch({
      type: DELETE_START
    });

    try {
      const response = await api.delete(`asks/${user.id}`);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: DELETE_SUCCESS
        });

        toast.success('Sponsorship deleted successfully!');

        if (isFunction(callback)) {
          callback();
        }
      } else {
        toast.error('Unable to delete sponsorship.');

        dispatch({
          type: DELETE_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: DELETE_FAILURE,
        payload: response
      });
    }
  };
}

export function clone(ask, history) {
  return async dispatch => {
    dispatch({
      type: CLONE_START
    });

    try {
      const response = await api.get(`asks/clone/${ask.id}`);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: CLONE_SUCCESS
        });

        toast.success('Sponsorship copied successfully!');

        history.push(`asks/edit/${data.ask.id}`);
      } else {
        toast.error('Unable to copy sponsorship.');

        dispatch({
          type: CLONE_FAILURE,
          payload: data.errors
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: CLONE_FAILURE,
        payload: response
      });
    }
  };
}

export function loadTerms() {
  return async dispatch => {
    try {
      dispatch({
        type: TERMS_LOAD
      });

      const response = await api.get('terms/ask');
      const { data } = response;

      if (data.success) {
        dispatch({
          type: TERMS_LOADED,
          payload: data.terms
        });
      } else {
        dispatch({
          type: TERMS_ERROR
        });
      }
    } catch (error) {}
  };
}



// WEBPACK FOOTER //
// ./src/components/app/asks/actions.js